<template>

  <div class="scroll-post"
       :class="{'scroll-post--single': !showSlideShow, 'scroll-post--back-to-front': backToFront}"
       ref="scrollPost"
       v-on:wheel="scroll"
       v-touch:start='touchDown'
       v-touch:moving='touchMove'
       v-touch:end='touchUp'
       v-on:mousedown='mouseDown'
       v-on:mouseup='mouseUp'
       v-on:mousemove='mouseMove'
       :style="getColorStyle">

    <HeroBackground :get-percent="getPercent" :slides="slides"/>

    <HeroTitle :style="getBorderStyle" :get-percent="getPercent" :slides="slides" :front-slide="frontSlide" :show-slide-show="showSlideShow" :autoplay-loading="autoplayLoading"/>
    <div class="scroll-post__row">
      <HeroDescription :style="getDescriptionStyle" :get-percent="getPercent" :slides="slides" :show-slide-show="showSlideShow"/>

      <HeroList :scroll-listener="scrollListener" :get-percent="getPercent" :slides="slides" :show-slide-show="showSlideShow" />
    </div>
    <div class="scroll-post__counter" v-if="showSlideShow">
      <span>{{currentSlideNumber}}/{{slides.length}}</span>
    </div>
  </div>

</template>

<script>
  import AdvancedScrollListener from './scrollListener';
  import HeroTitle from './HeroTitle.vue';
  import HeroBackground from './HeroBackground.vue';
  import HeroDescription from './HeroDescription.vue';
  import HeroList from './HeroList.vue';
  import {getUrl} from '../../utils/UrlHelper';

  const AUTOPLAY_SPEED = 8000;

  export default {
    components: {
      HeroTitle,
      HeroBackground,
      HeroDescription,
      HeroList,
    },
    mounted() {
      document.addEventListener("touchmove", (event) => {
        if (this.showSlideShow) {
          event.preventDefault();
        }
      }, {passive: false});
    },
    data() {
      return {
        percentageOfScroll: 0,
        backToFront: false,
        title: 'Profil',
        preventScroll: false,
        scrollListener: new AdvancedScrollListener(0, this.onScrollEvent),
        autoplayTimer: null,
        autoplayLoadingTimer: null,
        hasScroll: false,
        autoplayLoading: 0,
      };
    },
    watch: {
      $route(to, from) {
        if (to.name === 'frontpage') {
          this.backToFront = true;
          setTimeout(() => this.backToFront = false, 100);
        }
      },
      navigateTo(newValue) {
        if(newValue === null) {
          return;
        }
        this.preventScroll = true;
        this.scrollListener.goToSlide(newValue).then(() => {
          this.preventScroll = false;
          this.scrollListener.resetScroll();
          this.$store.commit('setHero', {
            slides: [this.$store.state.hero.slide],
            showSlideShow: false,
            navigateTo: null,
          });
        });
      },
      slides(newValue, oldValue) {
        if (newValue === oldValue) {
          return;
        }
        this.hasScroll = false;
        if (this.current) {
          const current = this.current;
          const position = this.slides.findIndex((slide) => current === slide.id);
          if (position > -1) {
            this.scrollListener.setSlide(position);
          }
        }
        this.startAutoplay();
      },
      currentSlideNumber(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.commit('setCurrentSlideNumber', newValue - 1);
        }
      }
    },
    computed: {
      slides() {
        const slides = this.$store.state.hero.slides;
        this.scrollListener.setNumberOfSlides(slides.length);
        return slides;
      },
      showSlideShow() {
        return this.$store.state.hero.showSlideShow;
      },
      current() {
        return this.$store.state.current;
      },
      navigateTo() {
        return this.$store.state.hero.navigateTo;
      },
      themeColor() {
        return this.$store.state.themeColor;
      },
      currentSlideNumber() {
        const currentSlide = Math.round(this.percentageOfScroll) + 1;
        if (currentSlide > this.slides.length) {
          return 1;
        }
        return currentSlide;
      },
      frontSlide() {
        return this.$store.state.hero.frontSlide;
      },
      getColorStyle() {
        const percentage = this.percentageOfScroll;
        let prev = Math.round(percentage);
        if (prev === this.slides.length) {
          prev = 0;
        }

        let slide = {};
        if (this.slides.length > prev) {
          slide = this.slides[prev];
        }
        if (slide.themeColor && this.themeColor !== slide.themeColor) {
          this.$store.commit('setThemeColor', slide.themeColor);
        }
        return {
          color: slide.color || 'white',
        };
      },
      getBorderStyle() {
        const percentage = this.percentageOfScroll;
        let prev = Math.round(percentage);
        if (prev === this.slides.length) {
          prev = 0;
        }
        let slide = {};
        if (this.slides.length > prev) {
          slide = this.slides[prev];
        }
        return {
          borderColor: slide.themeColor !== 'white' ? '#000' :'#fff',
        };
      },
      getDescriptionStyle() {
        const percentage = this.percentageOfScroll;
        let prev = Math.round(percentage);
        if (prev === this.slides.length) {
          prev = 0;
        }
        let slide = {};
        if (this.slides.length > prev) {
          slide = this.slides[prev];
        }
        return {
          color: slide.themeColor !== 'white' ? '#000' :'#fff',
        };
      },
    },
    methods: {
      startAutoplay() {
        clearTimeout(this.autoplayTimer);
        clearInterval(this.autoplayLoadingTimer);
        if (this.hasScroll || !this.showSlideShow) {
          return;
        }
        this.autoplayLoading = -15;
        this.autoplayLoadingTimer = setInterval(() => {
          this.autoplayLoading += 100 / 63;
          if (this.autoplayLoading >= 100) {
            this.autoplayLoading = 100;
            clearInterval(this.autoplayLoadingTimer);
          }
        }, 100);
        this.autoplayTimer = setTimeout(async () => {
          this.scrollListener.goToNextSlide();
          this.startAutoplay();
        }, AUTOPLAY_SPEED);
      },

      onScrollEvent(percentageOfScroll) {
        this.percentageOfScroll = percentageOfScroll;
      },

      getPercent(slide) {
        const percentage = this.percentageOfScroll;
        let prev = Math.floor(percentage);
        let next = Math.ceil(percentage);
        const p = percentage - prev;
        const slides = this.slides;
        const slideLength = slides.length;
        next = next >= slideLength ? 0 : next
        prev = prev >= slideLength - 1 ? slideLength - 1 : prev;
        const current = prev;
        const position = slides.findIndex((s) => s.id === slide.id);
        let relativePosition = position - current;
        let relativePositionFloat = position - percentage;
        if (relativePosition < -1) {
          relativePosition += slideLength
          relativePositionFloat += slideLength
        }
        if (position === slideLength - 1 && current === 0 && slideLength > 2) {
          relativePosition = -1;
          relativePositionFloat = -1 - p;
        }
        if (current === slideLength - 1 && position === slideLength - 1) {
          relativePosition = 0;
          relativePositionFloat = 0 - p;
        }
        return { position, relativePosition, relativePositionFloat, numberOfSlides: slideLength }
      },
      scroll(event) {
        if (!this.showSlideShow || this.preventScroll) {
          return;
        }
        this.hasScroll = true;
        clearTimeout(this.autoplayTimer);
        clearTimeout(this.autoplayLoadingTimer);
        this.autoplayLoading = 0;
        event.preventDefault();
        this.scrollListener.scroll(event);
      },
      touchDown(event) {
        if (!this.showSlideShow || this.preventScroll) {
          return;
        }
        this.mouseDown(event);
      },
      touchMove(event) {
        if (!this.showSlideShow || this.preventScroll) {
          return;
        }
        this.mouseMove(event);
      },
      touchUp(event) {
        if (!this.showSlideShow || this.preventScroll) {
          return;
        }
        this.mouseUp(event);
      },
      mouseDown(event) {
        if (!this.showSlideShow || this.preventScroll) {
          return;
        }
        this.hasScroll = true;
        clearTimeout(this.autoplayTimer);
        clearTimeout(this.autoplayLoadingTimer);
        this.autoplayLoading = 0;
        this.scrollListener.mouseDown(event);
      },
      mouseUp(event) {
        if (!this.showSlideShow || this.preventScroll) {
          return;
        }
        this.scrollListener.mouseUp(event);
      },
      mouseMove(event) {
        if (!this.showSlideShow || this.preventScroll) {
          return;
        }
        this.scrollListener.mouseMove(event);
      }
    },
    destroyed() {
      this.scrollListener.destroy();
      clearTimeout(this.autoplayTimer);
      clearTimeout(this.autoplayLoadingTimer);
    }
  };
</script>

<style lang="scss" >
  @import 'style.scss';
</style>
